import { loginFetch, get, post } from '@/utils/fetch'

export function loginByUserName(username, password, time, vcode) {
    const data = {
        username,
        password,
        time,
        vcode
    };
    return loginFetch({
        url: 'login',
        data
    })
}

export function getIndex() {
    return get({
        url: 'manage/pub/find'
    })
}
export function getInfo() {
    return get({
        url: 'manage/sys/iportal/userinfo'
    })
}

export function getMenu() {
    return get({
        url: 'manage/sys/iportal/menulist?appId=3&isShow=1'
    })
}

export function cancel() {
    return get({
        url: 'manage/sys/user/analog/1/1'
    })
}

export function logout(nodeId) {
    return post({
        url: 'manage/pub/loginout?nodeId=' + nodeId
    })
}

export function getNeedMobile() {
    return get({
        url: 'manage/pub/getConfig'
    })
}

export function sendMail(data) {
    return post({
        url: 'manage/pub/sendMail',
        data
    })
}

export function getUserEmail(loginName) {
    return get({
        url: `manage/pub/users/${loginName}`
    })
}

/**
 * 首次登陆，强制修改密码
 * @param {string} loginName 
 * @param {string} oldPassword 
 * @param {string} newPassword 
 * @param {string} email 可不传
 */
export function updateFirstLogin(data) {
    return post({
        url: `manage/pub/users/first-login`,
        data
    })
}

// 密码配置项校验原密码不能与新密码一致
export function checkOldPassword(loginName, oldPassword) {
    return get({
        url: 'manage/pub/verify/pwd',
        data: { loginName, oldPassword }
    })
}

// 密码配置项校验强度
export function checkPassword(loginName, password) {
    return get({
        url: 'manage/pub/check/pwd',
        data: { loginName, password }
    })
}

// 重置token
export function resetToken(refreshToken) {
    console.log(refreshToken)
    return post({
        url: `auth/refresh_token`,
        data: { refreshToken }
    })
}

export function loginAuth(data) {
    return post({
        url: `auth/login`,
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js